
// => Styling
import styles from './App.module.css';

// => Views
import StartView from './view/start/StartView';
import GameView from './view/game/GameView';
import SettingsView from './view/settings/SettingsView';
//import ShopView from './view/shop_old/ShopView';
import ShopView from './view/shop/ShopView';

// => Data
import { prefs } from './preferences';

// => Components
import StatusBar from './components/StatusBar';
import TitleScreen from './components/TitleScreen';

// => React hooks
import { useState, useRef, useEffect } from 'react';

// => 3rd party hooks
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import SecureLS from 'secure-ls';
/*const testAudio = require("./testMusic.mp3")*/

// ============
// Component
// ============
const App = () => {

  // Initialize SecureLS
  const ls = new SecureLS({ encodingType: 'aes' })

  // Query params
  // ---------
  let param_skip = (new URLSearchParams(window.location.search)).get("skip")
  let param_debug = (new URLSearchParams(window.location.search)).get("debug")

  // Refs
  // ---------
  const initialized = useRef(false)

  // States
  // ---------
  const [debugEnabled, setDebugEnabled] = useState(false)
  const [showTitle, setShowTitle] = useState(param_skip === null ? true : false)
  const [showGame, setShowGame] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const [showShop, setShowShop] = useState(false)

  const [cockChance, setCockChance] = useState(0)
  const [masculinity, setMasculinity] = useState(0)
  const [safeTimer, setSafeTimer] = useState(0)

  // Saved states
  // -----------
  const [saveTime, setSaveTime] = useState(new Date())
  const [saveCurrency, setSaveCurrency] = useState(0)
  const [saveCards, setSaveCards] = useState([])


  // Fullscreen functionality
  const fullscreenHandle = useFullScreenHandle()

  // Prevent page refresh by asking for confirmation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
        e.preventDefault()
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])


  // Methods
  // ---------
  function requestGameRegular() {
    // TODO: We can check here if we need anything before starting a game
    // TODO: implement game modes!
    setShowGame(true)
  }
  function requestGameExit() {
    save()
    setShowGame(false)
  }
  function requestSettings() {
    setShowSettings(true)
  }
  function requestShop() {
    setShowShop(true)
  }

  function toggleFullscreen() {
    try {
      if (fullscreenHandle.active) {
        fullscreenHandle.exit()
      } else {
        fullscreenHandle.enter()
      }
    } catch(e) {
      console.log(e)
    }
  }


  function onTitleContinued() {
    setShowTitle(false)
  }

  function addCards(cards = []) {
    let result = saveCards
    cards.forEach((c) => {
      let isCardInInventory = result.findIndex(f => f === c.id) >= 0
      if (!isCardInInventory) {
        result.push(c.id)
      }
    })
    setSaveCards(result)
    save()
  }

  function addCurrency(value) {
    //saveData.currency += value
    //save()
    let result = saveCurrency + value
    setSaveCurrency(result)
    //save()
  }

  function removeCurrency(value) {
    //let newCurrency = saveData.currency - value
    //if (newCurrency < 0) newCurrency = 0
    //saveData.currency = newCurrency
    // save()
    let result = saveCurrency - value
    if (result < 0) {
    result = 0
    }
    setSaveCurrency(result)
    //save()
  }

  useEffect(() => {
    if (!initialized.current) {
      return
    }
    save()
  }, [saveCurrency, saveCards])

  function save() {
    // set the current time as our last save time
    setSaveTime(new Date())
    
    // save encrypted
    ls.set('CR_SAVE', {
      time: saveTime,
      currency: saveCurrency,
      cards: saveCards
    })
    
    console.log("Data saved.", saveTime, saveCurrency, saveCards)
  }

  function load() {
    // Load encrypted
    let result = ls.get('CR_SAVE')

    // If we had savedata
    if (result) {
      // parse date object for last save time
      result.time = new Date(result.time)
      // set our data in state
      setSaveTime(result.time)
      setSaveCurrency(result.currency)
      setSaveCards(result.cards)

      console.log("Data loaded.", result)
    } else {
      // No save data available
      console.log("No savedata found.")
    }
  }


  // Initialization
  useEffect(() => {
    if (!initialized.current) {
      // Always enable debug mode when not in production environment
      if (process.env.NODE_ENV !== "production") {
        setDebugEnabled(true)
        console.log("Debug mode: Enabled")
      } else {
        // Otherwise, check if we have the debug param
        if (param_debug !== null) {
          setDebugEnabled(true)
          console.log("Debug mode: Enabled")
        }
      }

      if (param_skip !== null) {
        onTitleContinued()
      }

      load()
    }
  }, [param_debug, param_skip])

  // Set init
  useEffect(() => {
    initialized.current = true
  })

  // Save Reset promise
  const saveResetPromise = new Promise((resolve, reject) => {
    resolve()
  })


  // RENDER
  // ---------
  return (
    <div className={styles.app}>
    {/*<audio src={testAudio} controls={true}/>*/}
      <FullScreen handle={fullscreenHandle}
                  className={styles.fullscreenContainer}>

        {/* Title Screen */}
        {showTitle &&
          <TitleScreen delay={3}
                      onContinue={onTitleContinued} />
        }

        {/* Header */}
        <div className={styles.header}>
          <StatusBar showGame={showGame}
                    cockChance={cockChance}
                    masculinity={masculinity}
                    safeTimer={safeTimer}
                    currency={saveCurrency} />
        </div>

        {/* Content */}
        <div className={styles.content}>

          {/* Settings */}
          {showSettings &&
            <SettingsView requestClose={()=>setShowSettings(false)}
                          lastSaveTime={saveTime}
                          onResetSave={()=>saveResetPromise.then(ls.removeAll()).then(prefs.clear([prefs.PREF_DEBUG, prefs.PREF_TAGS])).then(window.location.reload())}
                          debugEnabled={debugEnabled} />
          }

          {/* Shop */}
          {showShop &&
            <ShopView requestClose={()=>setShowShop(false)}
                      currency={saveCurrency}
                      requestSubtractCurrency={(price)=>removeCurrency(price)}
                      unlockedCards={saveCards}
                      requestUnlockCards={(cs)=>addCards(cs)} />
          }

          {/* Start */}
          {!showGame &&
            <StartView onRegular={requestGameRegular}
                      onSettings={requestSettings}
                      onShop={requestShop} />
          }
          {/* Game */}
          { showGame &&
            <GameView onUpdateCockChance={(value) => setCockChance(value)}
                    onUpdateMasculinity={(value) => setMasculinity(value)}
                    onUpdateSafeTimer={(value) => setSafeTimer(value)}
                    requestGameExit={requestGameExit}
                    requestSettings={requestSettings}
                    requestFullscreenToggle={()=>toggleFullscreen()}
                    fullscreen={fullscreenHandle.active}
                    debugMode={debugEnabled}
                    onAddCurrency={(v)=>addCurrency(v)}
                    onRemoveCurrency={(v)=>removeCurrency(v)}
                    unlockedCards={saveCards} />
          }

        </div>

      </FullScreen>
    </div>
  );
}


export default App;
